import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import omit from 'lodash/fp/omit';
import Tile from '../Tile/Tile.js';
import styles from './icon-tile.css.js';

var IconTile = function IconTile(_ref) {
  var children = _ref.children,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      tileProps = _objectWithoutProperties(_ref, ["children", "fullWidth"]);

  return React.createElement("div", {
    className: cn(styles.iconTile, _defineProperty({}, styles.twoColumns, !fullWidth))
  }, React.createElement(Tile, tileProps, function (_ref2) {
    var Input = _ref2.Input,
        inputProps = _ref2.inputProps,
        Label = _ref2.Label,
        labelProps = _ref2.labelProps,
        Icon = _ref2.icon,
        rest = _objectWithoutProperties(_ref2, ["Input", "inputProps", "Label", "labelProps", "icon"]);

    return React.createElement("div", {
      className: cn(styles.content)
    }, React.createElement("span", {
      className: cn(styles.icon)
    }, React.createElement(Icon, {
      width: "1.5em",
      marginBottom: 0
    })), React.createElement("span", {
      className: cn(styles.label)
    }, React.createElement(Label, _extends({}, labelProps, {
      marginBottom: 0
    }), children)), React.createElement("span", {
      className: cn(styles.input)
    }, React.createElement(Input, _extends({}, omit(['focussed'], rest), inputProps))));
  }));
};

IconTile.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool
} : {};
export default IconTile;